import styles from "./index.module.css";
import { useEffect, useRef } from "react";
import BuyCard from "../../buyCard";
import VideoAlert from "../../../video-alert";
import PreAndNext from "../../preAndNext";
import Cast from "../../cast";
import LazyLoad from "react-lazyload";
const LonelinessAndCompanionshipDetail = ({
  isMobile,
  handleNextIndex,
  handleLastIndex,
  playVideo,
  pauseVideo,
  movieData,
}) => {
  useEffect(() => {
    new VideoAlert(
      {
        havePathElement: `.${styles.btsPlayButton}`,
        openAlert: pauseVideo,
      },
      []
    );
  });
  return (
    <div className={styles.ctn}>
      <div className={styles.movieInfo}>
        <div className={styles.movieNameBox}>
          <img
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-1.jpg"
            alt=""
            className={styles.movieName}
          />
          <img
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-2.jpg"
            alt=""
            className={styles.btsPlayButton}
            data-cursor-size="80px"
            data-video-src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-bts-02.mp4"
          />
        </div>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-3${
            isMobile ? "-m" : ""
          }.jpg`}
          alt=""
          className={styles.author}
        />
      </div>
      <div>
        <LazyLoad offset={300}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-4.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-4-cover.jpg"
            className={styles.abMedia1}
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-5${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>

      <div>
        <LazyLoad offset={300}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-6.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-6-cover.jpg"
            className={styles.abMedia2}
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-7${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>

      <div>
        <LazyLoad offset={300}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-8.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-8-cover.jpg"
            className={styles.abMedia3}
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-9${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>

      <div>
        <LazyLoad offset={300}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-10.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-10-cover.jpg"
            className={styles.abMedia4}
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-11${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>

      <div>
        <LazyLoad offset={300}             className={styles.abMedia5}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-12.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-12-cover.jpg"

          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-2-13${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>

      <Cast
        movieName={movieData.name}
        data={[
          {
            post: "PRODUCER/DIRECTOR/DP",
            name: "KRISTOFH POZO",
          },
          {
            post: "PRODUCER/DP",
            name: "YOLANDA BÁEZ",
          },
          {
            post: "BTS",
            name: "ERICK MONDRAGÓN",
          },
          {
            post: "ACTOR",
            name: "JOHHAN SERNA, LOUIS CERVANTES",
          },
          {
            post: "ACTRESS",
            name: "AMBER EDWARDS",
          },
          {
            post: "DOG TRAINER",
            name: "VALERIA AYVAR",
          },
          {
            post: "DOG",
            name: "ATENEA",
          },
        ]}
      />
    </div>
  );
};

export default LonelinessAndCompanionshipDetail;
